// lib
import { createAction } from "@reduxjs/toolkit";

export const showSearch = createAction("ux/search/show");
export const hideSearch = createAction("ux/search/hide");
export const showFavorites = createAction("ux/favorites/show");
export const hideFavorites = createAction("ux/favorites/hide");
export const windowResize = createAction("ux/window/resize");
export const setLanguage = createAction("ux/language/set");
